import gfm from 'remark-gfm'
import ReactMarkdown from 'react-markdown'
import { Panel } from 'rsuite'
import { GetStaticProps, NextPage } from 'next'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import CenterLayout from '../components/shared/CenterLayout'
import { getChangelog } from '../services/changelogServices'
import { Changelog } from '../ts/types/changelog.types'
import CustomText from '../components/base/CustomText'

type Props = {
  changelog: Changelog
}

const ChangelogPage: NextPage<Props> = ({ changelog }) => {
  return (
    <CenterLayout maxWidth={900} showLogo>
      <Panel bodyFill shaded className="bg-white">
        <div className="p-8">
          <CustomText size="heading-3" weight={700} className="text-gray-darker border-b border-gray pb-2">
            Historial de cambios
          </CustomText>

          <CustomText size="paragraph" weight={400} className="text-gray-darker italic my-5">
            Última actualización: {format(new Date(changelog.updated_at), 'PPP', { locale: es })}
          </CustomText>

          <CustomText size="paragraph" weight={400} className="text-gray-darker my-5">
            Todos los cambios importantes de SIMAP serán documentados aquí.
          </CustomText>

          <ReactMarkdown remarkPlugins={[gfm]} className="markdown">
            {changelog.content}
          </ReactMarkdown>
        </div>
      </Panel>
    </CenterLayout>
  )
}

ChangelogPage.auth = false

// eslint-disable-next-line require-jsdoc
export const getStaticProps: GetStaticProps = async () => {
  const changelog = await getChangelog()

  return {
    props: {
      changelog,
    },
    // Next.js will attempt to re-generate the page:
    // - When a request comes in
    // - At most once every 10 seconds
    revalidate: 60, // In seconds
  }
}

export default ChangelogPage
